import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PREDEFINED_TASKS_UPDATE } from "./apiRoutes";

export interface UpdatePredefinedTaskPayload {
  id: string;              // used in URL
  taskName: string;
  taskCategory: string;     // ID of category
  priority: string;
  taskTerm: string;         // ID of term
  taskDescription?: string; // optional
}

export interface UpdatePredefinedTaskResponse {
  data: [
    {
      records: [
        {
          id: string;
          name: string;
          category: string;
          priority: string;
          term: string;
          comments?: string;
          createdAt: string;
          updatedAt: string;
        }
      ];
    }
  ];
  message: string;
  success: boolean;
}

const updatePredefinedTask = async (payload: UpdatePredefinedTaskPayload) => {
  const { id, ...updateData } = payload;

  const response = await axiosAuth.put(
    `${PREDEFINED_TASKS_UPDATE}${id}`, // id in URL, no trailing slash
    updateData                         // payload matches backend field names
  );

  return response.data;
};

export const useUpdatePredefinedTaskMutation = (
  options?: UseMutationOptions<
    UpdatePredefinedTaskResponse,
    Error,
    UpdatePredefinedTaskPayload
  >
) => {
  return useMutation({
    mutationFn: updatePredefinedTask,
    ...options,
  });
};
